
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/ekmap-platform-map-javascript',
              siteOrigin: 'https://maplibre.github.io',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/ekmap-platform-map-javascript/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/controls/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-controls" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_controls.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/controls/basemap-control/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-controls-basemap-control" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_controls_basemap-control.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/controls/directions/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-controls-directions" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_controls_directions.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/controls/geocoder/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-controls-geocoder" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_controls_geocoder.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/controls/measure/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-controls-measure" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_controls_measure.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/examples/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-examples" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_examples.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/geocoding/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-geocoding" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_geocoding.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/geocoding/autocomplete/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-geocoding-autocomplete" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_geocoding_autocomplete.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/geocoding/forward/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-geocoding-forward" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_geocoding_forward.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/geocoding/reverse/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-geocoding-reverse" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_geocoding_reverse.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/javascript-api/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-javascript-api" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_javascript-api.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/javascript-api/administrative/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-javascript-api-administrative" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_javascript-api_administrative.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/javascript-api/basemap/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-javascript-api-basemap" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_javascript-api_basemap.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/javascript-api/controls/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-javascript-api-controls" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_javascript-api_controls.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/javascript-api/geocoding/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-javascript-api-geocoding" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_javascript-api_geocoding.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/javascript-api/navigation/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-javascript-api-navigation" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_javascript-api_navigation.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/javascript-api/picker-control/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-javascript-api-picker-control" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_javascript-api_picker-control.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/javascript-api/poi/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-javascript-api-poi" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_javascript-api_poi.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/javascript-api/service/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-javascript-api-service" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_javascript-api_service.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/layers/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-layers" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_layers.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/layers/cluster/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-layers-cluster" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_layers_cluster.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/layers/line/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-layers-line" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_layers_line.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/layers/point/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-layers-point" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_layers_point.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/layers/polygon/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-layers-polygon" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_layers_polygon.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/basemap/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-basemap" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_basemap.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/basemap_ctm/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-basemap-ctm" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_basemap_ctm.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/basemap_sat/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-basemap-sat" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_basemap_sat.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/bdm/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-bdm" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_bdm.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/bdm2022/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-bdm2022" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_bdm2022.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/change_type_map/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-change-type-map" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_change_type_map.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/ctm_style/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-ctm-style" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_ctm_style.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/filter_feature/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-filter-feature" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_filter_feature.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/lum/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-lum" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_lum.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/osm_style/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-osm-style" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_osm_style.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/realestate/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-realestate" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_realestate.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/realestate_style/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-realestate-style" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_realestate_style.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/sat_style/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-sat-style" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_sat_style.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/update_color_feature/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-update-color-feature" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_update_color_feature.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/maps/znm/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-maps-znm" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_maps_znm.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/marker/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-marker" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_marker.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/marker/marker-default/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-marker-marker-default" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_marker_marker-default.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/marker/marker_click/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-marker-marker-click" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_marker_marker_click.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/overview/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-overview" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_overview.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/picker-control/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-picker-control" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_picker-control.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/picker-control/place-picker/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-picker-control-place-picker" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_picker-control_place-picker.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/poi/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-poi" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_poi.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/poi/detail/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-poi-detail" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_poi_detail.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/poi/search-poi/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-poi-search-poi" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_poi_search-poi.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/popup/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-popup" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_popup.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/popup/popup-click-feature/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-popup-popup-click-feature" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_popup_popup-click-feature.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/popup/popup-default/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-popup-popup-default" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_popup_popup-default.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/rest-api/vector-tiles/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-rest-api-vector-tiles" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_rest-api_vector-tiles.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/routing/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-routing" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_routing.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/routing/direction/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-routing-direction" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_routing_direction.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/routing/isochrone/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-routing-isochrone" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_routing_isochrone.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/routing/match/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-routing-match" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_routing_match.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/routing/matrix/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-routing-matrix" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_routing_matrix.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/routing/nearest/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-routing-nearest" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_routing_nearest.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/routing/tsp/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-routing-tsp" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_routing_tsp.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/routing/vrp/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-routing-vrp" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_routing_vrp.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/administrative/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-administrative" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_administrative.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/distance_service/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-distance-service" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_distance_service.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/elevation_service/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-elevation-service" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_elevation_service.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/high_voltage_service/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-high-voltage-service" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_high_voltage_service.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/hydro_service/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-hydro-service" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_hydro_service.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/industrial_zone_service/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-industrial-zone-service" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_industrial_zone_service.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/land_use_plan_service/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-land-use-plan-service" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_land_use_plan_service.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/lum/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-lum" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_lum.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/population_service/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-population-service" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_population_service.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/protected_area_service/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-protected-area-service" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_protected_area_service.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/railway_corridor_service/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-railway-corridor-service" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_railway_corridor_service.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/soil_service/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-soil-service" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_soil_service.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-javascript/services/znm/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-javascript-services-znm" */
              '/home/toannc/ekmap-platform-map-javascript/_batfish_tmp/_ekmap-platform-map-javascript_services_znm.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };